import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

import moment from "moment";

import "./DateTime.scss";

function DateTimeInput({
  name,
  // label,
  required,
  disabled,
  type,
  value: initialValue,
  onChange
}) {
  const [innerValue, setInnerValue] = useState(initialValue);

  const handleChange = e => {
    setInnerValue(e.target.value);
  };

  useEffect(() => {
    if (initialValue) {
      const d = new Date(initialValue).toCorrectDateString();
      setInnerValue(d);
    }
  }, [initialValue]);

  const handleBlur = () => {
    if (innerValue) {
      console.log(innerValue);
      onChange({
        target: {
          name,
          value: innerValue,
          type: type || "datetime-local"
        }
      });
    }
  };

  return (
    <div className="rdt-container">
      <Input
        disabled={disabled}
        required={required}
        type={type || "datetime-local"}
        value={innerValue}
        onBlur={handleBlur}
        onChange={handleChange}
      />
    </div>
  );
}

DateTimeInput.propTypes = {
  required: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string,
  // label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment)
  ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

DateTimeInput.defaultProps = {
  // value: moment()
};

export default DateTimeInput;
